import React from "react";
import PropTypes from "prop-types";
import { getInitials } from "./utils/chatUtils";

const ChatHeader = ({ selectedThread, onBack, showBackButton }) => {
  const handleImageError = (e) => {
    e.target.style.display = 'none';
    const initialsSpan = e.target.parentElement.querySelector('span');
    if (initialsSpan) initialsSpan.style.display = 'grid';
  };

  return (
    <div className="pane-head">
      {showBackButton && selectedThread && (
        <button
          className="back-button"
          onClick={onBack}
          aria-label="Back to chat list"
        >
          ←
        </button>
      )}
      {selectedThread ? (
        <div className="title">
          <div className="avatar">
            {selectedThread.image ? (
              <img 
                src={selectedThread.image} 
                alt={selectedThread.name} 
                onError={handleImageError} 
              />
            ) : null}
            <span style={{ display: selectedThread.image ? 'none' : 'grid' }}>
              {getInitials(selectedThread.name)}
            </span>
          </div>
          <div className="user-info">
            <div className="user-name">{selectedThread.name || "Unknown"}</div>
            <div className="user-status">
              {selectedThread.online ? "ONLINE" : "OFFLINE"}
            </div>
          </div>
        </div>
      ) : (
        <div className="title">
          <div className="user-info">
            <div className="user-name" style={{ color: "#94a3b8" }}>
              No chat selected
            </div>
            <div className="user-status">Select a chat to start messaging</div>
          </div>
        </div>
      )}
    </div>
  );
};

ChatHeader.propTypes = {
  selectedThread: PropTypes.object,
  onBack: PropTypes.func.isRequired,
  showBackButton: PropTypes.bool,
};

ChatHeader.defaultProps = {
  selectedThread: null,
  showBackButton: false,
};

export default ChatHeader;

